/** @format */
import {
    Link as FeatherLink,
    LinkTarget,
} from '@mpb-com/feather/components/atoms/link';
import { useTranslation } from 'next-i18next';
import React, { ForwardRefRenderFunction, Ref, forwardRef } from 'react';

import { LinkProps } from './types';

export * from './types';

export * from '@mpb-com/feather/components/atoms/link/link.styles';
export { thirdPartyLinkStyles } from './link.styles';

const LinkWithRef: ForwardRefRenderFunction<
    HTMLAnchorElement | HTMLButtonElement,
    LinkProps
> = (
    { children, target, 'aria-label': ariaLabel, ...otherProps },
    ref: Ref<HTMLAnchorElement | HTMLButtonElement>
) => {
    const { t } = useTranslation();

    const getAriaLabel = () => {
        const labelWithFallback =
            ariaLabel ?? (typeof children === 'string' ? children : undefined);

        if (target !== LinkTarget.BLANK) {
            return labelWithFallback;
        }

        if (!labelWithFallback) {
            return t('(Opens in a new window)');
        }

        return t('{{label}} (Opens in a new window)', {
            label: labelWithFallback,
        });
    };

    return (
        <FeatherLink
            {...otherProps}
            target={target}
            aria-label={getAriaLabel()}
            ref={ref}
        >
            {children}
        </FeatherLink>
    );
};

export const Link = forwardRef(LinkWithRef);
